var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nut-sidenavbaritem",attrs:{"ikey":_vm.ikey},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('a',{staticClass:"item-title",attrs:{"href":"javascript:;"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }